import { Link, useNavigate } from 'react-router-dom';

function Contact() {
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);

    try {
      const response = await fetch('/contact-handler.php', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        navigate('/thanks');
      } else {
        alert('There was a problem submitting your form. Please try again.');
      }
    } catch (error) {
      alert('There was a problem submitting your form. Please try again.');
    }
  };

  return (
    <div className="contact-page">
      <header>
        <div className="header-container">
          <Link to="/" className="logo">
            RAOC Studio
          </Link>
          <nav>
            <a href="/#work">Work</a>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>
          </nav>
          <a
            href="https://instagram.com/raocstudio"
            target="_blank"
            rel="noopener noreferrer"
            className="instagram-link"
            aria-label="Follow us on Instagram"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" fill="currentColor"/>
            </svg>
          </a>
          <div className="header-actions">
            <Link to="/contact" className="btn">Start a Project</Link>
          </div>
        </div>
      </header>

      <main className="contact-container">
        <h1>Start Something</h1>
        <p>Tell us about your project—function, vibe, budget, timeline. We'll reply with a quick plan and next steps.</p>

        <div className="contact-form-wrapper">
          <form
            onSubmit={handleSubmit}
            className="contact-form"
          >

            <div className="form-field">
              <label>Name</label>
              <input required name="name" placeholder="Your name" />
            </div>

            <div className="form-row">
              <div className="form-field">
                <label>Email</label>
                <input required type="email" name="email" placeholder="you@example.com" />
              </div>
              <div className="form-field">
                <label>Budget</label>
                <select name="budget">
                  <option>Exploring</option>
                  <option>$1k–$3k</option>
                  <option>$3k–$8k</option>
                  <option>$8k–$20k</option>
                  <option>$20k+</option>
                </select>
              </div>
            </div>

            <div className="form-field">
              <label>Project Type</label>
              <select name="type">
                <option>Furniture</option>
                <option>Restoration</option>
                <option>Built‑in / Space</option>
                <option>Community Build</option>
              </select>
            </div>

            <div className="form-field">
              <label>What are we building?</label>
              <textarea
                required
                name="message"
                placeholder="Tell me the function, vibe, size, and any inspiration."
              ></textarea>
            </div>

            <button className="btn" type="submit">Send</button>
          </form>
        </div>

        <p className="back-link">
          <Link to="/">← Back to site</Link>
        </p>
      </main>

      <footer>
        <div className="footer-container">
          <div>© 2025 RAOC Studio — Craftsmanship • Quality • Integrity • Tradition • Artistry</div>
          <div className="footer-links">
            <a href="/#work">Work</a>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Contact;
